import { render, staticRenderFns } from "./ExamDo.vue?vue&type=template&id=79785ad0&scoped=true&"
import script from "./ExamDo.vue?vue&type=script&lang=js&"
export * from "./ExamDo.vue?vue&type=script&lang=js&"
import style0 from "./ExamDo.vue?vue&type=style&index=0&id=79785ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79785ad0",
  null
  
)

export default component.exports